<template>
<div :style="cssProps">
    <div class="logo-title d-flex flex-row justify-content-between align-items-center">
      <div>
        <img :src="info.logo ? info.logo : '../assets/images/sg_logo.svg'" @click="$router.push({name:'startPage'})">
        <div class="d-flex flex-column logo-col" style="padding-left:15px;">
          <h1 class="titleTop">Burger & Fries</h1>
          <h2 class="subTitleTop">Search or View Nearby Restaurants Below.</h2>
        </div>
      </div>
      <div>
        <button class="signIn d-flex align-items-center justify-content-around">
          <i class="fal fa-user-circle"></i>
          <span>Account</span>
        </button>
      </div>
  
    </div>
    <div class="allin"> 
    <div class="main-content d-flex flex-row justify-content-center align-items-center">
        <div class="d-flex flex-row justify-content-center align-items-center">
            <i class="fal fa-long-arrow-alt-left" @click="$router.go(-1)"></i>
            <div class="d-flex flex-column">
                <h1 class="title">LOG IN OR CREATE AN ACCOUNT</h1>
                <h2 class="subTitle">Enhance your ordering expirience.</h2>
            </div>
        </div>
        <div class="d-flex flex-column justify-content-center align-items-center empty-column"></div>
      
    </div>
    <div class="d-flex flex-row justify-content-around align-items-start columns">
      <div class="col-input d-flex flex-column justify-content-center align-items-center">
        <div class="column d-flex flex-column align-items-start justify-content-around">
          <h1>Let's setup your personal account</h1>
           <button class="method d-flex flex-column justify-content-between align-items-start" @click="toRegister">
            <i class="fas fa-user-circle"></i>
            <span>Create Account</span>
          </button>
        </div>
      </div>
      <div class="col-input d-flex flex-column justify-content-center align-items-center">
        
        <div class="column d-flex flex-column align-items-start justify-content-around" >
            <h1>Log in if you already have an account</h1>
            <input placeholder="Enter your email address to continue" v-model="email" name="emailaddress" v-validate="'required|email|max:128'">
            <input type="password" placeholder="Password" v-model="password">
            <span class="description">
              The Seven Girls app is paired with Olo service. If you have a Olo account, use your credentials to log into or create your Seven Girls account.
            </span>
          <div class="btn-last d-flex flex-row align-items-center justify-content-between">
              <button @click="submit">
                  <span>Continue</span>
              </button>
              <!-- <a href="#">Forgot Password?</a> -->
          </div>
        </div>
      </div>
    </div>
   </div>
    
</div>
   
</template>
<script>
import {mapState} from "vuex";
import axios from 'axios';
export default {
    name: 'signin',
    $_veeValidate: {
      validator: 'new', 
    },
    data() {
      return {
        email: null,
        password: null
      };
    },
    computed:{
        ...mapState(["info"]),
            cssProps() { return {
            '--main-color': this.info.color ? "#" + this.info.color : "#c12d39"
          }
        },
    },
    methods:{
       async submit(){
         const checking = await this.$validator.validateAll();
          if(checking){
            
            this.$store.commit('email.set', {emailaddress: this.email});
            //check if user exists
            // axios.get(`https://secure-badlands-41449.herokuapp.com/users/exists?email=${this.email}includePrivate=false&key=SPn4GGKDfK4ubhbWD0GbiHofFQwk7INP`)
            // .then(response => {
            //   console.log(response.data)
            // }).catch(error => {
            //   console.log(error)
            // })
            this.$router.push({name:'Signup'});
          }
       },
       toRegister(){
         this.$router.push({ name: 'Signup'})
       }
    }
    
}
</script>
<style scoped>
.btn-last{
    width: 100%;
    padding-top: 32px;
    cursor: pointer;
}
.btn-last a{
    
	opacity: 0.4;
	color: #000000;
	font-family: Poppins;
	font-size: 13px;
	line-height: 20px;
    text-decoration: underline;

}
.btn-last button span{
    
	color: #FFFFFF;
	font-family: Poppins;
	font-size: 13px;
	font-weight:500;
	line-height: 20px;

}
.btn-last button
{

	height: 48px;
	width: 201px;
	border-radius: 24px;
	background-color: var(--main-color);
}
.last-btn
{
   margin-top: 32px;
	height: 48px;
	width: 360px;
	border-radius: 24px;
	background-color: var(--main-color);
    margin-bottom: 76px;
}
.last-btn span{
  
	color: #FFFFFF;
	font-family: Poppins;
	font-size: 13px;
	font-weight: 500;
	line-height: 20px;
}

.allin
{
    position: absolute;
    margin: auto;
    top:80px;
    left: 0;
    bottom: 0;
    right: 10%;
    width: 70%;
}
.check{
    padding-top: 24px;
}
.check i{
  
	color:  rgba(0,0,0,0.15);
	font-family: "Font Awesome 5 Pro";
	font-size: 26px;
	line-height: 14px;
	text-align: left;
    padding-right: 20px;
    
}
.check span{
  
	opacity: 0.3;
	color: #000000;
	font-family: Poppins;
	font-size: 11px;
	font-weight: 500;
	line-height: 17px;

}
.check span a{
  color: #000000;
  text-decoration: underline;

}
.column
{
    padding-left: 3%;
}
.column input{
 
  border: none;
  outline: none;
  background-color: rgba(255,255,255,0);
  box-shadow: 0 1px 0 0 rgba(0,0,0,0.2);
  height: 56px;
  width: 350px;
  /* padding: 18px 5px; */
  margin-top: 16px;
}
.column input::placeholder
{
  
	opacity: 0.3;
	color: #000000;
	font-family: Poppins;
	font-size: 13px;
	font-weight: 500;
	line-height: 20px;
  /* margin-left: 0; */
  text-align: left;
}
.col-input h1{
    
	
	width: 300px;
	opacity: 0.8;
	color: #000000;
	font-family: Poppins;
	font-size: 16px;
	font-weight: bold;
	line-height: 25px;
    white-space: nowrap;
    text-align: left;

}
.col-input{
    width: 100%;
    padding-top: 48px;
}

.main-content
{
    width: 100%;
    padding-top: 47px;
}
.main-content i 
{
   
	opacity: 0.6;
	color: #000000;
	font-family: "Font Awesome 5 Pro";
	font-size: 32px;
	font-weight: 300;
	line-height: 32px;
    padding-right: 48px;

}
.title {
  font-family: "Poppins", sans-serif;
  font-weight: bold;
  font-size: 24px;
  text-transform: uppercase;
  opacity: 0.8;
  line-height: 35px;
  color: #000000;
  text-align: left;
  white-space: nowrap;
}
.subTitle {
  font-family: "Poppins", sans-serif;
  font-size: 16px;
  font-weight: 500;
  text-transform: capitalize;
  opacity: 0.4;
  line-height: 20px;
  color: #000000;
  text-align: left;
  white-space: nowrap
}
button
{
     border: none;
  padding: 0;
  background: none;
  outline: none;
}
.titleTop {
  font-family: "Poppins", sans-serif;
  font-weight: bold;
  font-size: 16px;
  text-transform: uppercase;
  opacity: 0.8;
  line-height: 26px;
  color: #000000;
  text-align: left;
}
.subTitleTop {
  font-family: "Poppins", sans-serif;
  font-size: 12px;
  font-weight: 500;
  text-transform: capitalize;
  opacity: 0.4;
  /* line-height: 20px; */
  color: #000000;
  text-align: left;
}
.signIn {
  font-family: "Poppins", sans-serif;
  font-weight: 600;
  font-size: 13px;
  color: #000000;
}
.signIn i {
  height: 21px;
  width: 20px;
  opacity: 0.8;
  color: #000000;
  font-family: "Font Awesome 5 Pro";
  font-size: 20px;
  font-weight: 300;
  line-height: 21px;
}
.signIn span {
  margin-left: 10px;
}
.logo-title {
  padding: 15px 25px;
  border: 1.5px solid rgba(0, 0, 0, 0.05);
}

.logo-title img {
  width: 50px;
  height: 50px;
  float: left;
  border-radius: 15px;
}
.description
{
  padding-top: 24px;
	opacity: 0.3;
	color: #000000;
	font-family: Poppins;
	font-size: 11px;
	font-weight: 500;
	line-height: 17px;
  width: 360px;
}
.method i {
  
	opacity: 0.8;
	color: var(--main-color);
	font-size: 20px;
	line-height: 21px;
}

.method span
{
  
	opacity: 0.8;
	color: var(--main-color);
	font-family: Poppins;
	font-size: 13px;
	font-weight: bold;
	line-height: 20px;
}
.method
{
  padding: 24px;
	height: 112px;
	width: 158px;
	border: 1px solid var(--main-color);
	border-radius: 16px;
	background-color: #FFFFFF;
  margin-top: 15px;
  cursor: pointer;
}
.empty-column{
  width: 50%;
}
@media screen and (max-width: 940px){
  .columns{
    flex-direction: column !important;
  }
  .empty-column{
    width: 0;
  }
  /* .allin{
    width: 90%;
  } */
}
</style>



// WEBPACK FOOTER //
// src/components/Register/signin.vue